import { Tooltip } from "@netapp/bxp-design-system-react";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { allMenus as i18nNamespace } from "../../../../../../i18n/namespace";
import { ReactComponent as IcClose } from "../assets/ic_close.svg";
import { ReactComponent as IcRefresh } from "../assets/ic_refresh.svg";
import { ReactComponent as IcSettings } from "../assets/ic_settings.svg";
import { useChatContext } from "../hooks";
import chatStyles from "./ChatContainer.module.scss";

const HeaderButton = ({ icon, alt, onClick, tooltipText, disabled = false }) => {
    return (
        <button
            className={chatStyles['header-action-button']}
            onClick={onClick}
            onMouseDown={e => e.preventDefault()}
            aria-label={alt}
            disabled={disabled}
        >
            {icon}
            {tooltipText && <Tooltip>{tooltipText}</Tooltip>}
        </button>
    );
};

HeaderButton.displayName = 'HeaderButton';

const ChatHeader = React.memo(() => {
    const { t } = useTranslation(i18nNamespace);
    const dispatch = useDispatch();
    const chatContext = useChatContext();

    // Clear conversation handler - reset all states to show Welcome Screen
    const handleRefreshClick = useCallback(() => {
        if (chatContext?.clearConversation) {
            chatContext.clearConversation();
        }
    }, [chatContext]);

    // Settings handler (placeholder)
    const handleSettingsClick = useCallback(() => {
        console.log("Settings clicked - implement settings panel");
    }, []);

    // Close widget handler
    const handleCloseClick = useCallback((e) => {
        dispatch({
            type: "MENU:CLOSE-WIDGET"
        });
    }, [dispatch]);

    return (
        <div className={chatStyles['header-actions-container']}>
            <HeaderButton
                icon={<IcRefresh />}
                alt={t("ai_refresh", "New conversation")}
                onClick={handleRefreshClick}
                tooltipText={t("ai_refresh_tooltip", "Start new conversation")}
                disabled={!chatContext?.hasMessages}
            />
            {/* <HeaderButton
                icon={<IcSettings />}
                alt={t("ai_settings", "Settings")}
                onClick={handleSettingsClick}
                tooltipText={t("ai_settings", "Settings")}
            /> */}
            <HeaderButton
                icon={<IcClose />}
                alt={t("ai_close", "Close")}
                onClick={handleCloseClick}
            />
        </div>
    );
});

ChatHeader.displayName = 'ChatHeader';

export default ChatHeader;